var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationCube4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_182752",
    "data-name": "\\uADF8\\uB8F9 182752",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.38,
    height: 32.024,
    viewBox: "0 0 27.38 32.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182041",
    "data-name": "\\uADF8\\uB8F9 182041",
    transform: "translate(0 7.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182039",
    "data-name": "\\uADF8\\uB8F9 182039",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130590",
    "data-name": "\\uD328\\uC2A4 130590",
    d: "M642.965,534.944l14.021,7.812V526.291l-14.021-7.812Z",
    transform: "translate(-642.965 -518.479)",
    fill: "#d8c7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182040",
    "data-name": "\\uADF8\\uB8F9 182040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130591",
    "data-name": "\\uD328\\uC2A4 130591",
    d: "M656.625,542.632a.246.246,0,0,1-.116-.03l-14.021-7.812a.237.237,0,0,1-.122-.208V518.118a.238.238,0,0,1,.354-.208l14.021,7.812a.238.238,0,0,1,.123.209v16.464a.239.239,0,0,1-.117.206A.248.248,0,0,1,656.625,542.632Zm-13.783-8.19,13.544,7.546V526.069l-13.544-7.546Z",
    transform: "translate(-642.365 -517.879)",
    fill: "#111"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182044",
    "data-name": "\\uADF8\\uB8F9 182044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182042",
    "data-name": "\\uADF8\\uB8F9 182042",
    transform: "translate(0.238 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130592",
    "data-name": "\\uD328\\uC2A4 130592",
    d: "M642.965,507.642l14.1,7.826,12.8-7.173-14.1-7.827Z",
    transform: "translate(-642.965 -500.468)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182043",
    "data-name": "\\uADF8\\uB8F9 182043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130593",
    "data-name": "\\uD328\\uC2A4 130593",
    d: "M656.706,515.345a.23.23,0,0,1-.116-.03l-14.1-7.826a.239.239,0,0,1,0-.417l12.8-7.173a.24.24,0,0,1,.232,0l14.1,7.827a.239.239,0,0,1,0,.416l-12.8,7.174A.248.248,0,0,1,656.706,515.345Zm-13.615-8.065,13.614,7.554,12.311-6.9L655.4,500.379Z",
    transform: "translate(-642.365 -499.869)",
    fill: "#111"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182047",
    "data-name": "\\uADF8\\uB8F9 182047",
    transform: "translate(14.282 7.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182045",
    "data-name": "\\uADF8\\uB8F9 182045",
    transform: "translate(0.239 0.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130594",
    "data-name": "\\uD328\\uC2A4 130594",
    d: "M691.537,537.156l-12.621,6.734v-16.63l12.621-7.091Z",
    transform: "translate(-678.916 -520.17)",
    fill: "#8b75f3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_182046",
    "data-name": "\\uADF8\\uB8F9 182046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130595",
    "data-name": "\\uD328\\uC2A4 130595",
    d: "M678.554,543.767a.24.24,0,0,1-.239-.239V526.9a.237.237,0,0,1,.122-.208l12.621-7.091a.235.235,0,0,1,.237,0,.24.24,0,0,1,.118.206v16.986a.237.237,0,0,1-.126.211l-12.621,6.734A.241.241,0,0,1,678.554,543.767Zm.238-16.729v16.093l12.145-6.48V520.214Zm12.383,9.756h0Z",
    transform: "translate(-678.315 -519.568)",
    fill: "#111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCube4);
export default __webpack_public_path__ + "static/media/information_cube4.9480762ccd6ab5e0436f5998642b403d.svg";
export { ForwardRef as ReactComponent };